import domainsFuc from './domains'
import originAxios from 'axios'
let setAxios = originAxios.create({
  baseURL:domainsFuc().domain,
  timeout: 15000 // request timeout
});
export default setAxios



// WEBPACK FOOTER //
// ./src/api/config.js